import axios from 'axios';

import getData from '../lib/dataHandling';
import data from '../../data/newsletter';

// ----------------------------
// Newsletter
// Newsletter subscription init

// eslint-disable-next-line import/prefer-default-export
export const ga = (...args) => {
  if (window.ga) {
    window.ga(...args);
  }
};

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#newsletter-form')) {
    const language = document.documentElement.lang;

    const setMessage = (path, text = '') => {
      const msg = document.querySelector('#form-message');
      msg.innerHTML = path ? getData(data, path, language) : text;
    };

    const checkMail = () => {
      const input = document.querySelector('#newsletter-email');
      const email = input.value;
      const emailpat = /^([a-z0-9])+([.a-z0-9_-])*@([a-z0-9])+(\.[a-z0-9_-]+)+$/i;

      if (!email || !emailpat.test(email)) {
        if (!email) {
          setMessage('newsletter.requiredMail');
          input.classList.add('is-error');
          return false;
        }
        setMessage('newsletter.notValidMail');
        input.classList.add('is-error');
        return false;
      }
      setMessage(null);
      input.classList.remove('is-error');

      ga('send', 'event', 'newsletter', 'subscribe', 'in-progress', {
        anonymizeIp: true,
      });

      return true;
    };

    const subscribe = () => {
      const input = document.querySelector('#newsletter-email');
      const button = document.querySelector('#submit-newsletter-button');
      const { value } = input;

      if (checkMail()) {
        axios({
          method: 'post',
          url: 'https://www.lbstudio.sk/services/newsletter',
          data: JSON.stringify({
            email: value,
            source: `lbstudio-${language}`,
            list: language === 'en' ? 'lbstudio_en' : 'lbstudio',
          }),
          crossDomain: true,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
          .then(() => {
            input.classList.add('text-color-success');
            button.innerHTML = getData(data, 'newsletter.success', language);
            setMessage('newsletter.confirmMessage');
            ga('send', 'event', 'newsletter', 'subscribe', 'success', {
              anonymizeIp: true,
            });
          })
          .catch(error => {
            input.classList.add('text-color-error');
            button.innerHTML = getData(data, 'newsletter.subscribe', language);
            let errorMessage = '';
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              errorMessage = error.response.data;
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              // console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              errorMessage = error.message;
            }
            setMessage(null, errorMessage);
            ga('send', 'event', 'newsletter', 'subscribe', 'error', {
              anonymizeIp: true,
            });
          });
      }
    };

    document
      .querySelector('#newsletter-form')
      .addEventListener('submit', event => {
        subscribe();
        event.preventDefault();
      });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/lib/newsletter.js